//
//
//
//
//
//
//
//
//
//
//
//
//

import TopCard from './_components/top_card'
import AroundPlates from './_components/around_plates'
import Life from './_components/life'
import Dev from './_components/dev'
import Price from './_components/price'
import Pick from './_components/pick'
import TradeLands from './_components/trade_lands'
import Recommedation from './_components/recommendation'

import pagination from '@/common/mixins/pagination'
import share from './_mixins/share'
import { sendUserLog } from '@/utils/log'

import Service from '@/service/plates'
import IndexService from '@/service/index'
import AccountService from '@/service/official_accounts'
import PublicService from '@/service/public'
import TradeService from '@/service/trade_data'

export default {
    mixins: [
        pagination,
        share
    ],
    components: {
        TopCard,
        TradeLands,
        AroundPlates,
        Life,
        Dev,
        Pick,
        Price,
        Recommedation
    },
    data () {
        return {
            pid: '',
            plate: {
                name: '',
                compliments: ''
            },
            presell_data: {},
            decoration: '',
            area: '',
            total_price: '',
            price: '',
            layout: '',
            req_waiting: false,
            lands: [],
            target: ''
        }
    },
    mounted() {
        const { id , target } = this.$route.query
        this.pid = id
        this.target = target
        this.init()
        this.visitLog()
    },
    methods: {
        async pick (liked) {
            if (this.req_waiting) {
                return
            }
            this.req_waiting = true
            let type = 'Fc::PlateNegativeVote'
            if (liked) {
                type = 'Fc::PlatePositiveVote'
            }
            await PublicService.like(type, this.pid, true)
            this.req_waiting = false
            const item = this.plate.votes[liked ? 'positive' : 'negative']
            item.is_liked = true
            item.like_count += 1
        },
        async follow () {
            if (await this.$checkUserLogging()) {
                if (this.req_waiting) {
                    return
                }
                this.req_waiting = true
                const method = this.plate.is_followed ? 'delFollows' : 'setFollows'
                await AccountService[method]({
                    followable_type: 'Fc::Plate',
                    followable_id: this.pid
                })
                this.plate.is_followed = !this.plate.is_followed
                this.req_waiting = false               
            }
        },
        visitLog () {
            const { id } = this.$route.query
            sendUserLog('fc_plate_view', {
                d_key: id.toString(),
                d_event: 1
            })
        },
        async init () {
            const { id } = this.$route.query
            const plate = await Service.getPlate(id)
            this.plate = plate
            this.getLandTrades()
            const presell_data = await Service.getPresales(id, {
                page: 1,
                per: 10
            })
            this.presell_data = presell_data
            await this.getData()
            if (this.target) {
                wx.pageScrollTo({
                    selector: `#${this.target}`
                })
            }
        },
        changeFilter (filter) {
            Object.keys(filter).forEach((key) => {
                this[key] = filter[key]
            })
            this.page = 1
            this.items = []
            this.getData()
        },
        async getData () {
            const opts = ['decoration', 'area', 'total_price', 'price', 'layout'].reduce((prev, key) => {
                if (this[key]) {
                    prev[key] = this[key]
                }
                return prev
            }, {})
            const data = await IndexService.getBuildings({
                page: this.page,
                plate_id: this.pid,
                ...opts
            })
            this.handleData(data)
        },
        async getLandTrades () {
            const data = await TradeService.getLandTrades({
                page: 1,
                per: 30,
                plate_id: this.pid
            })
            this.lands = data.items
        }
    }
}
